import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import TopSubmenu from "~/Admin/Layout/TopSubmenu/TopSubmenu";
import { connect } from "react-redux";
import { adminHttp } from "~/Admin/services/http";
import Moment from "react-moment";
import Pagination from "react-js-pagination";
import classnames from "classnames";
import { toggleArray } from "~/services/helpers";
import { Form } from "react-bootstrap";
import PopupActions from '../../../Components/PopupActions/PopupActions';
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import { ChevronRight } from "~/Components/Icons/Icons";
import AdminGuestPassword from "./AdminGuestPassword";
import { DownloadIcon, EditIcon } from '../../../Components/Icons/Icons';
import __ from 'lodash';
import { toast } from 'react-toastify';

const AdminGuestInvitation = ({ match, event, ...props }) => {

    const [response, setResponse] = useState({});
    const [filter, setFilter] = useState('pending');
    const [meta, setMeta] = useState('pending');
    const [selected, setSelected] = useState([]);
    const [searchParams, setSearchParams] = useState({
        name: '',
        email: '',
        invites: '',
        wave: '',
        addon: '',
        senton: '',
        language: '',
        status: '',
    });

    const changeFilter = (filter) => {
        setFilter(filter);
        setSelected([]);
        setSearchParams({
            name: '',
            email: '',
            invites: '',
            wave: '',
            addon: '',
            senton: '',
            language: '',
            status: '',
        })
    };

    const loadMeta = () => {
        adminHttp
            .get(`/events/${event.id}/invitations/meta`)
            .then(res => setMeta(res.data));
    };

    const loadData = (page = 1) => {
        adminHttp
            .get(`/events/${event.id}/invitations?filter=${filter}&page=${page}&name=${searchParams.name}&email=${searchParams.email}&invites=${searchParams.invites}&wave=${searchParams.wave}&addon=${searchParams.addon}&senton=${searchParams.senton}&language=${searchParams.language}${filter === 'all' ? `&rsvp_status=${searchParams.status}` : `&status=${searchParams.status}`}`)
            .then(res => {
                setResponse(res.data);
            });
    };

    const sendInvitations = () => {
        toast.promise(
            adminHttp.post(`/events/${event.id}/invitations/send`, { 'ids': selected }),
            {
                pending: 'Sending Invite(s)...',
                success: {
                    render() {
                        setSelected([]);
                        loadMeta();
                        loadData();
                        return 'Invite(s) sent'
                    }
                },
                error: 'Something went wrong!'
            }
        )
    };

    const deleteInvitations = () => {
        toast.promise(
            adminHttp.post(`/events/${event.id}/invitations/delete`, { 'ids': selected }),
            {
                pending: 'Deleting Gues(s)...',
                success: {
                    render() {
                        setSelected([]);
                        loadMeta();
                        loadData();
                        return 'Guest(s) deleted'
                    }
                },
                error: 'Something went wrong!'
            }
        )
    };

    useEffect(loadMeta, [event]);
    useEffect(loadData, [filter, event]);
    useEffect(loadData, [searchParams]);

    const handleSelectedChange = (id) => {
        setSelected(toggleArray(selected, id));
    };

    // DATA FILTER
    const filterUsers = __.debounce((type, value) => {
        setSearchParams((prev) => (
            {
                ...prev,
                [type]: value
            }
        ));
    }, 500);


    // SELECT ALL USERS
    const selectAll = () => {

        let selectedIds = [];

        if (response.data && response.data.length > 0 && response.data.length === selected.length) {
            setSelected([]);
        } else {
            response.data.map((item) => {
                selectedIds.push(item.id);
            })
        }

        setSelected(selectedIds);
    }

    return (
        <>
            <div className="data-uploads">
                <div className="d-flex justify-content-between no-gutters">
                    <div>
                        <h2>Guest Invitation</h2>
                    </div>
                    <div className="text-right">
                        <a href="/api/host/template" target="_blank" className="btn btn-secondary btn-sm mr-2">
                            <DownloadIcon classes="d-inline svg-16 mr-2" />Download template
                        </a>
                        <Link to={`${match.path}/validate`} className="btn btn-primary btn-sm">
                            Upload Guest Data
                        </Link>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <TopSubmenu>
                            <a href="#" onClick={e => changeFilter('pending')}
                                className={classnames({ 'active': filter === 'pending' })}>Invite Pending ({meta.pending})</a>

                            <a href="#" onClick={e => changeFilter('sent')}
                                className={classnames({ 'active': filter === 'sent' })}>Invite Sent ({meta.sent})</a>

                            <a href="#" onClick={e => changeFilter('accepted')}
                                className={classnames({ 'active': filter === 'accepted' })}>Invite Accepted ({meta.accepted})</a>

                            <a href="#" onClick={e => changeFilter('all')}
                                className={classnames({ 'active': filter === 'all' })}>Invite Log ({meta.all})</a>

                            <a href="#" onClick={e => changeFilter('declined')}
                                className={classnames({ 'active': filter === 'declined' })}>Invite Declined ({meta.declined})</a>
                        </TopSubmenu>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card shadow-sm bg-white mt-3">
                            <div className="card-body">
                                <div className="table-scrollable">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                {['pending', 'sent', 'accepted', 'declined', 'all'].indexOf(filter) > -1
                                                    && <th scope="row">
                                                        <Form.Check
                                                            inline
                                                            type="checkbox"
                                                            checked={response.data && response.data.length > 0 && response.data.length === selected.length}
                                                            onClick={() => selectAll()}
                                                        />
                                                    </th>
                                                }
                                                <th scope="col">Guest Name</th>
                                                <th scope="col">Guest Email</th>
                                                {['pending', 'sent', 'accepted', 'all'].indexOf(filter) > -1 && <th scope="col">Invitees</th>}
                                                {/* <th scope="col">NEOM Department</th> */}
                                                <th scope="col">Wave/Package</th>

                                                {['pending'].indexOf(filter) > -1 && <th scope="col">Added On</th>}
                                                {['sent'].indexOf(filter) > -1 && <th scope="col">Sent On</th>}

                                                {['pending', 'sent', 'accepted', 'all'].indexOf(filter) > -1 && <th scope="col">Language</th>}
                                                {/* {['declined'].indexOf(filter) > -1 && <th scope="col">Declined At</th>} */}
                                                <th scope="col">RSVP Status</th>
                                                <th scope="col"></th>
                                                <th scope="col">Edit</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td></td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Search Name"
                                                        onChange={(searchValue) => filterUsers('name', searchValue.target.value)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Search Email"
                                                        onChange={(searchValue) => filterUsers('email', searchValue.target.value)}
                                                    />
                                                </td>
                                                {filter !== 'declined' && <td></td>}
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Search Wave"
                                                        onChange={(searchValue) => filterUsers('wave', searchValue.target.value)}
                                                    />
                                                </td>
                                                {filter === 'pending' && <td></td>}
                                                {filter === 'sent' && <td></td>}
                                                {filter !== 'declined' && <td></td>}
                                                {filter === 'all' ? <td>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Search Status"
                                                        onChange={(searchValue) => filterUsers('status', searchValue.target.value)}
                                                    />
                                                </td> : <td></td>}
                                                <td></td>
                                            </tr>
                                            {response.data?.map((invitation) => (
                                                <tr key={invitation.id}>
                                                    {<td scope="row">
                                                        <Form.Check
                                                            key={invitation.id}
                                                            inline
                                                            type="checkbox"
                                                            id={'upload-' + invitation.id}
                                                            value={invitation.id}
                                                            checked={selected.includes(invitation.id)}
                                                            onClick={e => handleSelectedChange(invitation.id)}
                                                        />
                                                    </td>}
                                                    <td>{invitation.main_guest?.full_name || invitation.user?.full_name}</td>
                                                    <td>{invitation.main_guest?.email || invitation.user?.email}</td>
                                                    {['pending', 'sent', 'accepted', 'all'].indexOf(filter) > -1 && <td>{invitation?.guest_allowance}</td>}
                                                    <td>{invitation.wave?.name || '-'}/{invitation.package?.name || '-'}</td>
                                                    {['pending'].indexOf(filter) > -1 && <td><Moment format="DD/MM/YYYY h:mm:ss a" date={invitation.created_at} /></td>}
                                                    {['sent'].indexOf(filter) > -1 && <td><Moment format="DD/MM/YYYY h:mm:ss a" date={invitation.sent_at} /></td>}
                                                    {/* {['declined'].indexOf(filter) > -1 && <td><Moment format="DD/MM/YYYY h:mm:ss a" date={invitation.metrics.find(m => m.action == 'rsvp_declined')?.created_at || invitation.updated_at} /></td>} */}
                                                    {['pending', 'sent', 'accepted', 'all'].indexOf(filter) > -1 && <td>{invitation.user?.language?.name || '-'}</td>}
                                                    <td>{invitation.rsvp_status}</td>
                                                    <td>
                                                        {invitation.rsvp_status === 'declined' && (
                                                            <Link to={`/guests/registration/${invitation.id}`}>
                                                                <ChevronRight />
                                                            </Link>
                                                        )}

                                                        {invitation.rsvp_status !== 'declined' && (
                                                            <AdminGuestPassword invitation={invitation} />
                                                        )}
                                                    </td>
                                                    <td>
                                                        <Link to={`/guests/registration/${invitation.id}`}>
                                                            <EditIcon />
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {response.per_page < response.total && (
                                    <Pagination
                                        activePage={response.current_page}
                                        itemsCountPerPage={response.per_page}
                                        totalItemsCount={response.total}
                                        pageRangeDisplayed={5}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        onChange={(page) => {
                                            setSelected([]);
                                            loadData(page);
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {filter === 'pending' && selected.length > 0 && (
                <PopupActions>
                    <ConfirmedButton
                        confirmTitle={"Delete Invitation"}
                        confirmText={`You are about to DELETE an invitations of ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                        onClick={deleteInvitations}
                        className="btn btn-danger btn-xs mr-3">
                        Delete Selected ({selected.length})
                    </ConfirmedButton>
                    <ConfirmedButton
                        confirmTitle={"Send Invitation"}
                        confirmText={`You are about to send an invitation email to the ${event.name} to ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                        onClick={sendInvitations}
                        className="btn btn-secondary btn-xs mr-3">
                        Send Selected ({selected.length})
                    </ConfirmedButton>
                </PopupActions>
            )}

            {filter === 'sent' && selected.length > 0 && (
                <PopupActions>
                    <ConfirmedButton
                        confirmTitle={"Delete Invitation"}
                        confirmText={`You are about to DELETE an invitations of ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                        onClick={deleteInvitations}
                        className="btn btn-danger btn-xs mr-3">
                        Delete Selected ({selected.length})
                    </ConfirmedButton>

                    <ConfirmedButton
                        confirmTitle={"Send Invitation"}
                        confirmText={`You are about to re-send an invitation email to the ${event.name} to ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                        onClick={sendInvitations}
                        className="btn btn-secondary btn-xs mr-3">
                        Re-Send Selected ({selected.length})
                    </ConfirmedButton>
                </PopupActions>
            )}

            {['declined', 'accepted'].includes(filter) && selected.length > 0 && (
                <PopupActions>
                    <ConfirmedButton
                        confirmTitle={"Delete Invitation"}
                        confirmText={`You are about to DELETE an invitations of ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                        onClick={deleteInvitations}
                        className="btn btn-danger btn-xs mr-3">
                        Delete Selected ({selected.length})
                    </ConfirmedButton>
                </PopupActions>
            )}

            {['all'].includes(filter) && selected.length > 0 && (
                <PopupActions>
                    <ConfirmedButton
                        confirmTitle={"Delete Invitation"}
                        confirmText={`You are about to DELETE an invitations of ${selected.length} users. Are you sure you want to proceed? This cannot be undone.`}
                        onClick={deleteInvitations}
                        className="btn btn-danger btn-xs mr-3">
                        Delete Selected ({selected.length})
                    </ConfirmedButton>
                </PopupActions>
            )}
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminGuestInvitation);
